import { onReady } from '../core/dom-ready.js';
import { initBootstrap } from '../core/bootstrap.js';
import { initFormBootstrap } from '../core/form-bootstrap.js';
import { initMarkerModules } from '../core/marker-bootstrap.js';
import { initModules } from '../core/module-loader.js';
import { initArticleActions } from '../modules/actions.js';
import { initCookieNotice } from '../modules/cookie.js';
import { initDevScheme } from '../modules/dev-scheme.js';
import { initHeader } from '../modules/header.js';
import { initScrollTop } from '../modules/scroll-top.js';
import { initSmoothScroll } from '../modules/smooth-scroll.js';
import { initTechnologies } from '../modules/technologies.js';

onReady(() => {
  initBootstrap();
  initTechnologies();
  initSmoothScroll();
  initArticleActions();
  initFormBootstrap();
  initHeader();
  initCookieNotice();
  initDevScheme();
  initScrollTop();
  initMarkerModules();
  initModules();
});
